module.exports = __webpack_public_path__ + "img/gold.d59b0170.png";